import { ReactEventHandler, ReactNode, useCallback, useState } from "react";
import { ASSET_PREFIX } from "utils/constants";
import styles from './EasySteps.module.css';
import { useRefArray } from "hooks/useRefArray";
import RoundedButton from "components/RoundedButton";
import Arrow10x20 from "components/svg/Arrow10x20";
import AspectRatioContainer from "components/about-us/AspectRatioContainer";


const howItWorksSteps: [title: string, text: ReactNode, videoFilename: string][] = [
  [
    'Choose your plan',
    'Play online via our Lite and Premium plans or enter for free via the post',
    `${ASSET_PREFIX}/videos/HowItWorksStep1.mp4`
  ],
  [
    'Pick your numbers',
    <>Select 4 main numbers 1 to 55<br /> and 1 bonus number 1 to 10</>,
    `${ASSET_PREFIX}/videos/HowItWorksStep2.mp4`
  ],
  [
    'Match numbers to win',
    'We draw the winning numbers every Tuesday and Friday at 5pm',
    `${ASSET_PREFIX}/videos/HowItWorksStep3.mp4`
  ],
  [
    'Choose your Prize',
    'The more numbers you match, the bigger the prize you get to choose!',
    `${ASSET_PREFIX}/videos/HowItWorksStep4.mp4`
  ],

];

const EasySteps = () => {
  const [hadUserInteraction, setHadUserInteraction] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [setVideoElementRef, videoElementRef] = useRefArray<HTMLVideoElement>();
  
  const onEnded: ReactEventHandler<HTMLVideoElement> = useCallback((e) => {
    if (hadUserInteraction) {
      return;
    }
    const index = parseFloat(e.currentTarget?.getAttribute('data-index') as any);
    if (isNaN(index)) {
      return;
    }
    changeIndex((index + 1) % howItWorksSteps.length);
  }, [hadUserInteraction]);

  const changeIndex = (index: number) => {
    setSelectedIndex(index);
    videoElementRef[index]?.play().catch(e => {
      // The video failed to play for whatever reason. Make sure the promise is handled so it isn't reported to Sentry
      console.log('EasySteps video failed to player', e)
    });
  }
  
  return (
    <>
      <div className={styles.easyStepsContainer + ' withReducedSpacing'}>
        {howItWorksSteps.map((x, index) =>
          <div key={index} className={styles.easyStepsItem}>
            <div className={`${styles.videoContainer} ${selectedIndex == index ? styles.selected : ''}`}>
              <AspectRatioContainer width={626} height={396} innerClassName={styles.aspectRatioRoundedCorners}>
                <video autoPlay={index == 0} muted playsInline ref={setVideoElementRef(index)} onEnded={onEnded} data-index={index}>
                  <source src={x[2]}></source>
                </video>
              </AspectRatioContainer>
            </div>
            <div className={`${styles.videoTextContainer} ${selectedIndex == index ? styles.selected : ''}`}>
              <p className="aboutUsTypographyHeaderMedium">{x[0]}</p>
              <p>{x[1]}</p>
            </div>
          </div>
        )}
        <div className={styles.howItWorksCarouselDots} onClick={() => setHadUserInteraction(true)}>
          <button disabled={selectedIndex < 1} className={styles.previousSlide} aria-label="Previous slide" onClick={()=> changeIndex(Math.max(0, selectedIndex - 1))}>
            <Arrow10x20/>
          </button>
          {howItWorksSteps.map((_, index) => (
            <button
              key={index}
              onClick={() => changeIndex(index)}
              className={index === selectedIndex ? styles.selected : ''}
            >{index + 1}</button>
          ))}
          <button disabled={selectedIndex >= howItWorksSteps.length - 1} className={styles.nextSlide} aria-label="Next slide" onClick={()=> changeIndex(Math.min(howItWorksSteps.length - 1, selectedIndex + 1))}>
            <Arrow10x20/>
          </button>
        </div>
        <div className={styles.buttonContainer}>
          <RoundedButton rebrandDm2025 href="/choose-your-plan">Enter now</RoundedButton>
        </div>
      </div>
    </>
  );
}

export default EasySteps;